import * as React from "react";
import { Redirect } from "react-router";
import LayoutRoute, { LayoutRouteProps } from "../LayoutRoute";
import IfAuthenticated from "../IfAuthenticated";

interface Props extends LayoutRouteProps {
  anonOnly?: boolean;
  redirect?: string;
  scope?: string;
}

const AuthRoute = (props: Props) => {
  const { anonOnly, redirect, scope } = props;

  if (anonOnly) {
    return (
      <IfAuthenticated fallback={<LayoutRoute {...props} />}>
        <Redirect to={redirect || "/"} />
      </IfAuthenticated>
    );
  } else {
    return (
      <IfAuthenticated
        scope={scope}
        fallback={<Redirect to={redirect || "/login"} />}
      >
        <LayoutRoute {...props} />
      </IfAuthenticated>
    );
  }
};

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/components/AuthRoute/AuthRoute.tsx